import React, { useState, useMemo, useEffect } from 'react'
import styled from 'styled-components/macro';
import { useSelector, useDispatch } from 'react-redux'
import { fetchSubweb } from 'redux/subwebSlice'
import { Spacer } from 'components/atoms';
import { InputIcon, Pagination } from 'components/molecules'
import { PageTable } from 'components/organisms'
import { injectIntl } from 'react-intl'
import { intlType } from 'types'
import { useDebounce } from 'react-use'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { generateEditorPath } from 'services/generators';
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { useMutation } from 'react-query'
import { archivePage } from 'services/requests'
import { deleteDraft } from 'redux/draftsSlice'
import { useEditorContext, actions } from 'context/EditorContext';

const SubwebsPagesTable = ({ intl, subweb }) => {
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const dispatch = useDispatch()
  const { pages: subwebPages, isLoadingTable, totalRecords } = useSelector(
    (state) => state.subweb
  )
  const history = useHistory()
  const [, dispatchEditor] = useEditorContext();
  const [archive, { isLoading }] = useMutation(archivePage, {
    onSuccess: (data, variables) => {
      dispatch(deleteDraft(variables.pageId))
      dispatchEditor({ type: actions.PAGE_ARCHIVE })
      toast.success(
        <Toast
          type="success"
          title="Página ocultada"
          description="Ocultada ambas as versão"
        />
      );
      dispatch(fetchSubweb({ subweb, page: 1, search: '' }))
    },
    onError: (err) => {
      toast.error(
        <Toast
          type="error"
          title="Erro a ocultar a página."
          description={err.message}
        />
      );
    }
  })

  useEffect(
    () => {
      if (subweb) {
        setSearch('')
        setPage(1)
        dispatch(fetchSubweb({ subweb, page: 1, search: '' }))
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [subweb]
  )

  useDebounce(
    () => {
      if (subweb && !isLoadingTable) {
        dispatch(fetchSubweb({ subweb, page, search }))
      }
    },
    350,
    [search, page]
  )

  const handleSearch = (e) => {
    setSearch(e.target.value)
    setPage(1)
  }

  const noDataText = useMemo(() => {
    if (isLoadingTable) return ' '
    return search === '' ? 'Sem resultados' : `Sem resultados para a pesquisa "${search}"`
  }, [search, isLoadingTable])

  const handlePageEdit = ({ subweb, pageId }) => {
    history.push(generateEditorPath({ pageId, subweb }))
  }

  const handlePageArchive = ({ subweb, pageId }) => {
    archive({ subweb, pageId, allLanguages: true })
  }

  return (
    <TableWrapper>
      <Spacer bottom="xl">
        <InputIcon
          icon="search"
          placeholder={intl.formatMessage({ id: 'page.search' })}
          value={search}
          onChange={handleSearch}
        />
      </Spacer>
      <Spacer bottom="m">
        <Pagination
          onChange={(nextPage) => setPage(nextPage)}
          current={page}
          total={totalRecords}
        />
      </Spacer>
      <PageTable
        subweb={subweb}
        pages={subwebPages}
        loading={isLoadingTable}
        noDataText={noDataText}
        handlePageEdit={handlePageEdit}
        handlePageArchive={handlePageArchive}
        isLoadingActions={isLoading}
      />
      <Spacer top="m">
        <Pagination
          onChange={(nextPage) => setPage(nextPage)}
          current={page}
          total={totalRecords}
        />
      </Spacer>
    </TableWrapper>
  )
}

const TableWrapper = styled.div``

SubwebsPagesTable.propTypes = {
  intl: intlType.isRequired,
  subweb: PropTypes.string.isRequired
}

export default injectIntl(SubwebsPagesTable)
